import styled from 'styled-components'
import { useLocation } from 'react-router'

import { media } from 'styles/media'
import { useGetCurrentUserQuery } from 'hooks/useQueries'

import IncompleteBookingCard from '../../../components/cards/IncompleteBookingCard'

const Wrapper = styled.div`
  ${media.md`
    max-width: 250px;
  `}
`

export const IncompleteBookingIndicator = styled.div`
  position: absolute;
  top: -3px;
  right: -3px;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme?.['-ds-core-200']?.value};
`

export const useIncompleteBooking = () => {
  const { pathname } = useLocation()

  const { data: currentUserData } = useGetCurrentUserQuery()

  const isCheckout = pathname.match(/payment/)
  const data = currentUserData?.currentUser?.incompleteBookings?.[0]

  const showAlert = !isCheckout && !!data

  return {
    showAlert,
    data,
  }
}

const IncompeteBooking = () => {
  const { showAlert: showIncompleteBooking, data: incompleteBooking } =
    useIncompleteBooking()

  if (!showIncompleteBooking) {
    return null
  }

  return (
    <Wrapper>
      <IncompleteBookingCard
        bookingId={incompleteBooking?.id}
        title={incompleteBooking?.listing?.title}
        image={incompleteBooking?.promoImage?.thumb}
        dates={{
          startDate: incompleteBooking?.startDate,
          endDate: incompleteBooking?.endDate,
        }}
      />
    </Wrapper>
  )
}

export default IncompeteBooking
